var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReloadItem(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "icon/action/reload_item_24px"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6948_75",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 21,
    height: 22
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "icon/action/reload_item_24px_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86541 18.2736C7.05594 18.2736 8.01919 19.2452 8.01919 20.4328C8.01919 21.6203 7.05594 22.592 5.86541 22.592C4.67487 22.592 3.7008 21.6203 3.7008 20.4328C3.7008 19.2452 4.67487 18.2736 5.86541 18.2736ZM9.01046 16.0972C9.01046 16.471 9.04204 16.8374 9.10267 17.194L3.57902 17.194V15.0348L9.09703 15.0341C9.04008 15.3801 9.01046 15.7352 9.01046 16.0972ZM17.5811 3.1592L18.5678 1H22V3.1592H19.9008L16.8643 9.74485C16.426 9.65154 15.9713 9.60244 15.5052 9.60244C15.1909 9.60244 14.8818 9.62477 14.5793 9.66794L16.584 5.3184H3.83125L6.72817 10.7164L11.8679 10.7157C11.0466 11.2719 10.3593 12.0113 9.8648 12.8751L6.72817 12.8756C5.94096 12.8756 5.24822 12.433 4.89135 11.7636L1.13375 4.757C0.745394 4.04447 1.24921 3.1592 2.04691 3.1592H17.5811ZM16.5 12C18.0125 12 19.3875 12.55 20.35 13.65L22 12V17.5H16.5L18.975 15.025C18.2875 14.475 17.4625 14.0625 16.5 14.0625C14.575 14.0625 13.0625 15.575 13.0625 17.5C13.0625 19.425 14.575 20.9375 16.5 20.9375C17.6 20.9375 18.5625 20.3875 19.25 19.5625H21.5875C20.7625 21.625 18.8375 23 16.5 23C13.475 23 11 20.525 11 17.5C11 14.475 13.475 12 16.5 12Z",
    fill: "#5D6B72"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6948_75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE2\x86\xB3 Color"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 24,
    height: 24,
    fill: "#5D6B72"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadItem);
export default __webpack_public_path__ + "static/media/reload-item.158dee95.svg";
export { ForwardRef as ReactComponent };